import ModalForm from "./Form";
import {
	CLC_CALENDAR,
	DATATABLE_EXPORT,
} from "../../../../Config/ApiUrl";
import {urlGenerator} from "../../../../Helpers/AxiosHelper";

export const Schema = {
	components: { ModalForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			tableId: "CLC_CALENDAR-table",
			rowData: {},
			formId: "CLC_CALENDAR-form",
			tableColumns: [ 
				
				{
					title: "Calendar Name",
					type: "text",
					key: "academic_calendar_name",
				},
				{
					title: "Term",
					type: "text",
					key: "term",
				},
				{
					title: "School Year",
					type: "custom-html",
					key: "school_year_from",
					modifier: (value,rowData) => {
						return rowData.school_year_from
							? rowData.school_year_from + '/' + rowData.school_year_to
							: '';
					}
				},
				{
					title: "Date Start",
					type: "custom-html",
					key: "date_start",
					modifier: (value) => {
						if (!value) return "-";
						const date = new Date(value);
						if (isNaN(date)) return value;
						const options = { month: "short", day: "2-digit", year: "numeric" };
						return date.toLocaleDateString("en-US", options);
					},
				},
				{
					title: "Date End",
					type: "custom-html",
					key: "date_end",
					modifier: (value) => {
						if (!value) return "-";
						const date = new Date(value);
						if (isNaN(date)) return value;
						const options = { month: "short", day: "2-digit", year: "numeric" };
						return date.toLocaleDateString("en-US", options);
					},
				},
				{
					title: "Early Bird Discount",
					type: "custom-html",
					key: "early_bird_discount",
					modifier: (value) => {
						return this.formattedIDR(value) ? this.formattedIDR(value) : this.formattedIDR(0);
					},
				},
				{
					title: "Date Start (Early Bird)",
					type: "custom-html",
					key: "date_start_early_bird",
					modifier: (value) => {
						if (!value) return "-";
						const date = new Date(value);
						if (isNaN(date)) return value;
						const options = { month: "short", day: "2-digit", year: "numeric" };
						return date.toLocaleDateString("en-US", options);
					},
				},
				{
					title: "Date End (Early Bird)",
					type: "custom-html",
					key: "date_end_early_bird",
					modifier: (value) => {
						if (!value) return "-";
						const date = new Date(value);
						if (isNaN(date)) return value;
						const options = { month: "short", day: "2-digit", year: "numeric" };
						return date.toLocaleDateString("en-US", options);
					},
				},
				{
					title: this.$t("is_active"),
					type: "custom-html",
					key: "is_active",
					isVisible: true,
					modifier: (value) => {
						let ClassName = "danger";

						if (value === 1) ClassName = `success`;
						else if (value === 0) ClassName = `warning`;

						return `<span class="badge badge-sm badge-pill badge-${ClassName}">${
							value ? "Active" : "Inactive"
						}</span>`;
					},
				},
			],
			ENDPOINT: CLC_CALENDAR,
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "ClcCalendar",
				url: CLC_CALENDAR,
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				actions: [
					{
						title: this.$t("view"),
						icon: "eye",
						type: "viewClcCalendarDetail",
					},
					{
						title: this.$t("edit"),
						icon: "edit",
						type: "none",
						component: "app-add-modal",
						modalId: "CLC_CALENDAR-form",
					},
					{
						title: this.$t("delete"),
						icon: "trash",
						type: "none",
						component: "app-confirmation-modal",
						modalId: "demo-delete",
					},
				],
				filters: [
					{
						title: this.$t("is_active"),
						type: "checkbox",
						key: "is_active",
						option: [
							{ id: true, value: "Active" },
							{ id: false, value: "Inactive" },
						],
					},
				],
				showFilter: true,
				showSearch: true,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 10,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {
		/**
		 * Delete confirmed $emit Form confirmation modal
		 */
		onDelete() {
			let url = CLC_CALENDAR + "/" + this.rowData.id;
			this.deleteLoader = true;
			this.axiosDelete(url)
				.then((response) => {
					this.deleteLoader = false;
					$("#demo-delete").modal("hide");
					this.onCancelDelete();
					this.$toastr.s(response.data.message);
					// this.searchAndSelectFilterOptions();
				})
				.catch(({ err }) => {})
				.finally(() => this.$hub.$emit(`reload-${this.tableId}`));
		},
		onCancelDelete() {
			this.deleteConfirmationModalActive = false;
			this.reSetData();
		},
		reSetData() {
			this.rowData = {};
			this.selectedUrl = "";
		},
		formattedIDR(value) {
			// Format the value as IDR
			return new Intl.NumberFormat("id-ID", {
				style: "currency",
				currency: "IDR",
				minimumFractionDigits: 0,
			}).format(value);
		},
	},
};
